import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { href: "#story", label: "Our Story" },
  { href: "#offer", label: "What We Offer" },
  { href: "#impact", label: "Impact" },
  { href: "#volunteer", label: "Volunteer" },
  { href: "#contact", label: "Contact" },
];

export default function Header({ onDonate }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-14 sm:top-16 md:top-[68px] inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-md border-b border-[#EADAB9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center">
          <img
            src="/hearthside-logo.png"
            alt="Hearthside Gathering"
            className={`w-auto object-contain transition-all duration-300 ${scrolled ? "h-24 md:h-28" : "h-32 md:h-40"}`}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="hearth-link text-sm font-medium text-[#1F1A17]/85"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-donate-button"
            onClick={onDonate}
            className="btn-hearth hidden sm:inline-flex items-center justify-center rounded-full bg-[#C25934] hover:bg-[#A04728] text-white px-6 py-2.5 text-sm font-semibold tracking-wide"
          >
            Donate
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2 text-[#1F1A17]"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#FDFBF7] border-t border-[#EADAB9] px-6 py-6 space-y-4">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block text-base font-medium text-[#1F1A17]"
            >
              {item.label}
            </a>
          ))}
          <button
            data-testid="nav-donate-button-mobile"
            onClick={() => { setOpen(false); onDonate(); }}
            className="w-full rounded-full bg-[#C25934] text-white py-3 font-semibold"
          >
            Donate
          </button>
        </div>
      )}
    </header>
  );
}
